import { render, staticRenderFns } from "./ProcessList.vue?vue&type=template&id=23cf4f33&scoped=true&"
import script from "./ProcessList.vue?vue&type=script&lang=js&"
export * from "./ProcessList.vue?vue&type=script&lang=js&"
import style0 from "./ProcessList.vue?vue&type=style&index=0&id=23cf4f33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf4f33",
  null
  
)

export default component.exports